// react-select's default #ccc arrow and × are 1.61:1 on white (WCAG 1.4.11 asks 3:1). gray-500 is 3.41:1 at rest, gray-600 5.33:1 when focused or hovered.
const indicatorColor = (provided, state) => ({
  ...provided,
  color: state.isFocused ? "var(--color-gray-600)" : "var(--color-gray-500)",
  ":hover": { color: "var(--color-gray-600)" }
});

// GROWTH-7436: react-select's resting control border (#ccc) is 1.61:1 on white. gray-500 is 3.41:1. A focused control keeps react-select's
// own blue border. The hover rule is set too, because react-select re-colours the border on hover.
const control = (provided, state) =>
  state.isFocused
    ? provided
    : { ...provided, borderColor: "var(--color-gray-500)", "&:hover": { ...provided["&:hover"], borderColor: "var(--color-gray-500)" } };

const PLACEHOLDER_COLOR = "var(--color-gray-600)";

// The fake "no value" options ({ value: "", label: "Select" } / "Unselect") look like a placeholder. A real option whose name only
// contains those letters ("Select Law Group") or that has value "" ("My account", "Custom") is a chosen value and stays dark.
const isNoValueOption = data => data?.value === "" && /^\s*(un)?select\s*$/i.test(String(data?.label ?? ""));

export const customStyles = {
  control,
  menuList: (provided, state) => {
    if (state.selectProps.isAddCustomScrollbar && state.children.length > 8) {
      return {
        ...provided,
        overflowY: "auto",
        height: "250px",
        lineHeight: "1em",
        "&::-webkit-scrollbar": {
          "-webkitAppearance": "none"
        },
        "&::-webkit-scrollbar:vertical": {
          width: "11px"
        },
        "&::-webkit-scrollbar:horizontal": {
          width: "11px"
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "8px",
          border: "2px solid white",
          backgroundColor: "rgba(0, 0, 0, .5)"
        }
      };
    }
    return {
      ...provided
    };
  },
  menuPortal: base => ({
    ...base,
    zIndex: 9999
  }),
  // GROWTH-7427: react-select's own placeholder (#808080) is 3.95:1 on white. gray-600 is 5.33:1 on white, 5.02:1 on #f8f8fa,
  // 4.88:1 on #f4f5f6, and matches the text-field placeholders (GROWTH-7428).
  placeholder: provided => ({
    ...provided,
    color: PLACEHOLDER_COLOR
  }),
  singleValue: (provided, state) => {
    return {
      ...provided,
      color: isNoValueOption(state?.data) ? PLACEHOLDER_COLOR : "#333"
    };
  },
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: state.selectProps.isNewSelectedColor && state.isFocused ? "#F8F8FA" : state.isFocused ? "#F2FAFD" : "#ffffff",
      color: "#353546",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "20px",
      padding: state.data.isAddBorder ? "8px 20px 20px" : "8px 20px",
      borderBottom: state.data.isAddBorder ? "1px solid #EAEAEA" : "",
      marginBottom: state.data.isAddBorder ? "20px" : ""
    };
  },
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: indicatorColor,
  clearIndicator: indicatorColor,
  valueContainer: provided => {
    return {
      ...provided,
      padding: "2px 8px 2px 10px"
    };
  }
};

export const customStylesMulti = {
  control,
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#F2FAFD" : "#ffffff",
    color: "#353546",
    padding: "8px 20px"
  }),
  placeholder: provided => ({
    ...provided,
    color: "#abafb9"
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: indicatorColor,
  clearIndicator: indicatorColor,
  valueContainer: provided => ({
    ...provided,
    padding: "0 20px 20px"
  }),
  multiValue: provided => ({
    ...provided,
    background: "#F2FAFD",
    margin: "20px 20px 0 0",
    borderRadius: "4px",
    padding: "8px 12px",
    display: "flex",
    alignItems: "center"
  }),
  multiValueRemove: provided => ({
    ...provided,
    color: "#ABAFB9",
    width: "25px",
    height: "25px",
    paddingLeft: "5px",
    "& svg": {
      width: "100%",
      height: "100%"
    }
  })
};

export const customStylesMultiMobile = {
  control,
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#F2FAFD" : "#ffffff",
    color: "#353546"
  }),
  indicatorSeparator: () => ({ display: "none" }),
  clearIndicator: (provided, state) => ({ ...indicatorColor(provided, state), paddingLeft: "0px", paddingRight: "0px" }),
  dropdownIndicator: (provided, state) => ({ ...indicatorColor(provided, state), paddingLeft: "0px" }),
  valueContainer: provided => ({
    ...provided,
    minHeight: "50px",
    height: "50px",
    overflowY: "auto"
  }),
  multiValue: provided => ({
    ...provided,
    background: "#F2FAFD",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center"
  }),
  multiValueRemove: provided => ({
    ...provided,
    color: "#ABAFB9",
    width: "25px",
    height: "25px",
    paddingLeft: "5px",
    "& svg": {
      width: "100%",
      height: "100%"
    }
  })
};
